import { useCallback, useRef, useState } from 'react';

export interface UseIsFocusedResult {
  readonly onFocus: () => void;
  readonly onBlur: () => void;
  readonly isFocused: boolean;
}

export type UseIsFocused = () => UseIsFocusedResult;

const useIsFocused: UseIsFocused = () => {
  const [isFocused, setIsFocused] = useState(false);
  const blurTimeout = useRef<number>();

  const onFocus = useCallback(() => {
    window.clearTimeout(blurTimeout.current);
    setIsFocused(true);
  }, []);

  const onBlur = useCallback(() => {
    blurTimeout.current = window.setTimeout(() => {
      setIsFocused(false);
    }, 0);
  }, []);

  return {
    onFocus,
    onBlur,
    isFocused,
  };
};

export default useIsFocused;
